import { getIsInitialSpaRender } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import { getRouterState } from '@atlassian/react-resource-router';
import { getInitialLoadTaskId } from './getInitialLoadTaskId.tsx';

type CorrelatedTaskId = string | undefined;

type CorrelatedTaskIdInput = {
	experience: string;
	explicitTaskId?: CorrelatedTaskId;
};

/**
 * Attaches the correlating SSR `taskId` to a terminal event for the experience
 * the current route opts into SSR `taskStart` emission for (via
 * `analyticsOptions.taskStart` — the same route config the SSR side uses).
 *
 * The trace id is only attached on the initial SPA render, so SPA-to-SPA
 * transitions and embeds don't carry a stale SSR trace.
 *
 * Falls back to any `explicitTaskId` provided by the caller.
 */
export const getCorrelatedTaskIdAttributes = ({
	experience,
	explicitTaskId,
}: CorrelatedTaskIdInput): { taskId?: CorrelatedTaskId } => {
	const isRouteExperienceMatch =
		getRouterState().route?.analyticsOptions?.taskStart?.experience === experience;

	const shouldAttachTaskId = isRouteExperienceMatch && getIsInitialSpaRender();

	const taskId = (shouldAttachTaskId ? getInitialLoadTaskId() : undefined) ?? explicitTaskId;

	return taskId ? { taskId } : {};
};
